import styles from "./StepAccordion.module.css";

interface StepAccordionProps {
  id: string;
  title: string;
  completed: boolean;
  expanded: boolean;
  onToggleExpand: () => void;
  onToggleComplete?: () => void;
  children: React.ReactNode;
}

export const StepAccordion = ({
  id,
  title,
  completed,
  expanded,
  onToggleExpand,
  onToggleComplete,
  children,
}: StepAccordionProps) => {
  return (
    <div>
      <s-clickable
        onClick={onToggleExpand}
        padding="base"
        inlineSize="100%"
        borderRadius="base"
        aria-expanded={expanded}
        aria-controls={`${id}-panel`}
      >
        <s-stack direction="inline" gap="base" alignItems="center">
          <span
            role={onToggleComplete ? "checkbox" : undefined}
            aria-checked={onToggleComplete ? completed : undefined}
            aria-label={
              onToggleComplete ? `Marcar ${title} como completado` : undefined
            }
            tabIndex={onToggleComplete ? 0 : undefined}
            onClick={
              onToggleComplete
                ? (e: React.MouseEvent) => {
                    e.stopPropagation();
                    onToggleComplete();
                  }
                : undefined
            }
            onKeyDown={
              onToggleComplete
                ? (e: React.KeyboardEvent) => {
                    if (e.key === " " || e.key === "Enter") {
                      e.preventDefault();
                      e.stopPropagation();
                      onToggleComplete();
                    }
                  }
                : undefined
            }
            className={styles.stepIcon}
          >
            <s-icon
              type={completed ? "check-circle-filled" : "circle-dashed"}
              tone={completed ? "success" : "auto"}
            />
          </span>
          <span className={expanded ? styles.sectionSelectedTitle : undefined}>
            {title}
          </span>
        </s-stack>
      </s-clickable>

      {expanded && (
        <div id={`${id}-panel`} role="region" aria-label={title}>
          <s-box padding="large-200">
            <s-stack direction="block" gap="large-200">
              {children}
            </s-stack>
          </s-box>
        </div>
      )}

      <s-divider />
    </div>
  );
};
